import React from "react"
import questions from "../assets/asset2"

const PageNotFound = () => {
    return (
        <h1>Error 404 PAGE NOT FOUND</h1>
    )
}
export default PageNotFound;